import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './stores/index'
// import './assets/main.css'
import './assets/icons'
// import './registerServiceWorker.js'
import './Services/GlobalVariables'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import DrawerLayout from 'vue-drawer-layout'

Vue.use(DrawerLayout);
Vue.component('v-select',vSelect)

new Vue({
    store,
    router,
    render: (h) => h(App)
}).$mount('#app')
